<template>
    <div class="loader" v-if="$store.state.loader > 0">
        <div>
            <img src="@/assets/loader.gif">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loader',
    }
</script>


<style>
.loader {
    position: fixed;
    z-index: 999999;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(155, 155, 155, 0.8);
}

    .loader > div {
        background: #FFFFFF;
        width: 16%;
        min-width: 200px;
        position: absolute;
        top: 35%;
        left: 42%;
    }

        .loader > div > img {
            display: block;
            margin: auto;
        }

</style>



// WEBPACK FOOTER //
// src/components/Loader.vue